import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { NegotiationOfferModel } from "@/modules/candidate/models/negotiationOfferModel"

@Serializable
export class NegotiationModel {
  uid: string = ""
  startPriceValue: number = 0
  startPriceValueCurrency: string = ""
  startLocalPriceValue: number = 0
  startLocalPriceValueCurrency: string = ""
  offers: NegotiationOfferModel[] = []

  constructor(data?: Partial<NegotiationModel> | null) {
    Object.assign(this, data)
  }
}
